// extracted by mini-css-extract-plugin
export default {"main":"PictureMain_main__mk+iC","overlay":"PictureMain_overlay__0pSQi","mainContent":"PictureMain_mainContent__vWeo2"};